export default __webpack_public_path__ + "static/media/team-block-art-about.bcb0b34a.svg";